/** 收集踩点记录详情中所有具有唯一标识的动态字段。 */
const collectDynamicComponents = (items: any[], components: any[]) => {
  if (!Array.isArray(items)) return;

  items.forEach((item: any) => {
    if (item?.identification) {
      components.push(item);
    }

    collectDynamicComponents(item?.propertyConfigVOList, components);
    collectDynamicComponents(item?.childList, components);
  });
};

/** 踩点字段存在有效值时才覆盖机会点中同唯一标识字段。 */
const hasSynchronizableValue = (textValue: any) => textValue !== undefined && textValue !== null && textValue !== '' && textValue !== 'null';

/**
 * 根据唯一标识同步踩点记录详情字段到机会点动态表单字段。
 * 踩点模板独有字段忽略，机会点模板独有字段保持原值。
 */
export const synchronizeSpotSurveyValues = (propertyGroupVOList: any[], chanceComponents: any[]) => {
  const spotSurveyComponents: any[] = [];
  const importedComponents: any[] = [];
  const importedIdentifications: string[] = [];
  collectDynamicComponents(propertyGroupVOList, spotSurveyComponents);

  spotSurveyComponents.forEach((spotSurveyComponent: any) => {
    const { identification, textValue } = spotSurveyComponent;
    if (!identification || !hasSynchronizableValue(textValue)) return;

    chanceComponents.filter((chanceComponent: any) => chanceComponent?.identification === identification).forEach((chanceComponent: any) => {
      chanceComponent.textValue = textValue;
      importedComponents.push(chanceComponent);
    });
    if (importedComponents.some((chanceComponent: any) => chanceComponent.identification === identification) && !importedIdentifications.includes(identification)) {
      importedIdentifications.push(identification);
    }
  });

  return {
    importedComponents,
    importedIdentifications,
  };
};
